import { useForm } from "react-hook-form";
import { Button, InputField } from "../../../components/forms";
import Datepicker from "../../../components/generic/Datepicker";
import { ListPicker } from "../../../components/generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { addressRegex, emailReg, numReg, textReg } from "../../../utils/regex";
import { countries } from "../../../constant/data";
import { useSelector } from "react-redux";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { GoPlus } from "react-icons/go";
import { FaSave } from "react-icons/fa";
import { useEffect, useState } from "react";
import {
  onAddEmployeeemgContact,
  onAddEmployeeKin,
  onGetemployeeEmgContact,
  onGetemployeeKin,
  onUpdateContactDetails,
  onUpdateEmployeeDetails,
  onUpdateKinDetails,
} from "../../../services/employee";
import { toast } from "react-toastify";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";

export default ({ details }: any) => {
  const dateofbirthPick = usePickerhook();
  var { control, handleSubmit, watch, setValue } = useForm();
  const departmentPickhook = usePickerhook();
  const nationalityPickhook = usePickerhook();
  const genderPickhook = usePickerhook();
  const maritalPickhook = usePickerhook();
  const countrypicked = usePickerhook();
  const { SelectedOrg, selectedEmployee } = useStateGetter();
  const watchedFields = watch([
    "firstname",
    "lastname",
    "email",
    "address",
    "emgname",
    "phone",
    "emgphone",
    "kinaddress",
    "kinemail",
    "kinfirstname",
    "kinlastname",
    "kinphone",
    "kinrelationship",
  ]);
  const [kindetails, setkindetails] = useState<any>({});
  const [emgdetails, setemgdetails] = useState<any>({});
  const { config, isloading } = useStateGetter();

  const { setLoading, setselectedEmpl } = useStateSetter();

  const areFieldsFilled = watchedFields.every(
    (field) =>
      field !== "" &&
      field !== undefined &&
      // maritalPickhook.pickedRole &&
      genderPickhook.pickedRole &&
      nationalityPickhook.pickedRole
  );




  const onSubmit = async (data: any) => {
    console.log(data);
    setLoading(true);

  
  }
  
 
 

  useEffect(()=>{
setValue("name",selectedEmployee.name)
setValue("phone",selectedEmployee.phone)
setValue("position",selectedEmployee.position)
setValue("email",selectedEmployee.workEmail)
setValue("phone",selectedEmployee.workPhone)
  },[selectedEmployee, emgdetails])
  return (
    <div>
      <div className=" grid grid-cols-2 gap-4  	 ">
        <InputField
          name="contact"
          title="Contact"
          placeholder={"Contact"}
           control={control}
          rules={{
            required: "is required",
            pattern: {
              value: textReg,
              message: "Invalid",
            },
          }}
        />
        <InputField
          name="lastname"
          title="Lastname"
          placeholder={"lastname"}
           control={control}
          rules={{
            required: "last name is required",
            pattern: {
              value: textReg,
              message: "Invalid last name",
            },
          }}
        />

        <InputField
          name="email"
          title="Email Address"
          placeholder={"Enter Email Address"}
           control={control}
          isDisabled={true}
          rules={{
            required: "Email Address is required",
            pattern: {
              value: emailReg,
              message: "Invalid Email Address",
            },
          }}
        />

        <InputField
          name="phone"
          title="Phone number"
          placeholder={"Enter phone number"}
          control={control}
           rules={{
            required: "Phone number is required",
            pattern: {
              value: numReg,
              message: "Invalid phone number",
            },
          }}
        />

       
      </div>

      <p className="text-sm font-semibold ">Address</p>
      <InputField
        name="address"
        title="Address"
        placeholder={"Enter addresss"}
        
        control={control}
        rules={{
          required: "Address is required",
          pattern: {
            value: addressRegex,
            message: "Invalid address",
          },
        }}
      />
      <InputField
        name="address_additional"
        title="Additional information (Optional)"
        placeholder={"Enter additional info"}
        defaultvalue=""
        control={control}
      />

      <div className="grid grid-cols-2 gap-4">
        <InputField
          name="city"
          title="City"
           placeholder={"City"}
          control={control}
          rules={{
            required: "City is required",
            pattern: {
              value: addressRegex,
              message: "Invalid city",
            },
          }}
        />
        <ListPicker
          hook={countrypicked}
          title="Country"
          list={countries}
          defaultvalue={
            selectedEmployee?.country
              ? countries.filter((i) => i.name == selectedEmployee?.country)[0]
              : countries.filter((i) => i.name == SelectedOrg?.country)[0]
          }
        />
      </div>

     
      
 
        

      <div className="w-full  flex justify-end items-center">
        <Button
          width={200}
          disabled={false}
          text={
            <>
              <FaSave size={15} className=" mx-1 inline" /> Save Changes{" "}
            </>
          }
          onBtnClick={handleSubmit(onSubmit)}
        />
      </div>
    </div>
  );
};
